import { render, staticRenderFns } from "./FileBrowserView.vue?vue&type=template&id=48bee5e0&"
import script from "./FileBrowserView.vue?vue&type=script&lang=js&"
export * from "./FileBrowserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports